<template>
  <div>
    <v-card class="pa-6 rounded-xl mb-6" elevation="3">
    <div class="d-flex align-center mb-4">
      <v-icon color="primary" class="mr-3">mdi-filter-variant</v-icon>
      <h3 class="text-h6 font-weight-bold mb-0">Búsqueda General</h3>
    </div>
    
    <v-row align="center">
      <v-col cols="12" md="8" lg="6">
        <v-text-field
          v-model="search"
          outlined
          clearable
          solo
          flat
          hide-details
          prepend-inner-icon="mdi-magnify"
          label="Buscar en todos los campos"
          placeholder="Nombre, DNI, fecha, estado..."
          class="rounded-lg"
          
        >
          
        </v-text-field>
      </v-col>
      
     
    </v-row>
  </v-card>
  <v-card class="rounded-xl" elevation="4">
    <v-card-title class="pa-6 pb-4">
      <div class="d-flex align-center">
        <v-avatar color="primary" size="40" class="mr-4">
          <v-icon color="white">mdi-table-large</v-icon>
        </v-avatar>
        <div>
          <h3 class="text-h5 font-weight-bold mb-0">Registro de Asistencias</h3>
          <p class="text-caption text--secondary mb-0">{{ items.length }} registros encontrados</p>
        </div>
      </div>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        text
        class="rounded-lg"
        @click="$emit('refresh')"
        :loading="loading"
      >
        <v-icon small left>mdi-refresh</v-icon>
        Actualizar
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      :search="search"
      :items-per-page="15"
      class="elevation-0"
      :mobile-breakpoint="600"
      :disable-pagination="false"
      fixed-header
     
      dense
    >
      
      <template v-slot:item.entrada="{ item }">
        <span>{{ formatDateTime(item.entrada) }}</span>
      </template>

      <template v-slot:item.salida="{ item }">
        <span>{{ item.salida ? formatDateTime(item.salida) : '—' }}</span>
      </template>

      <template v-slot:item.estado="{ item }">
        <v-chip small :color="item.salida ? 'info' : 'success'" dark>
          {{ item.salida ? 'Salida' : 'Presente' }}
        </v-chip>
      </template>

      <template v-slot:no-data>
        <div class="pa-6 text-center grey--text">Sin registros para mostrar</div>
      </template>
    </v-data-table>
  </v-card>
  </div>
</template>

<script>
export default {
  name: 'VisitorsTable',
  props: {
    items: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
   
  },
  data() {
    return {
      search: '',
      headers: [
        { text: 'Nombre', value: 'visitante.nombre' },
        { text: 'DNI', value: 'visitante.dni' },
        { text: 'Entrada', value: 'entrada' },
        { text: 'Salida', value: 'salida' },
        { text: 'Estado', value: 'estado', sortable: false },
      ],
    };
  },
  methods: {
    
  
    
    formatDateTime(iso) {
      if (!iso) return '—';
      const d = new Date(iso);
      const date = d.toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric' });
      const time = d.toLocaleTimeString('es-AR', { hour: '2-digit', minute: '2-digit' });
      return `${date} ${time}`;
    },
  },
};
</script>

<style scoped></style>
